import { ContentFilters } from 'src/app/core/models/core.models';

/**
 * Flattens one value into `FormData` under PHP's `key[sub][sub]` bracket
 * convention.
 */
function appendFormData(formData: FormData, keyBase: string, value: any): void {
  if (value instanceof File) {
    formData.append(keyBase, value);
  } else if (typeof value === 'object' && value !== null) {
    for (const subKey in value) {
      if (value.hasOwnProperty(subKey)) {
        appendFormData(formData, `${keyBase}[${subKey}]`, value[subKey]);
      }
    }
  } else {
    formData.append(keyBase, value);
  }
}

/** The period + paging + sort + filter body every feed-results request carries. */
export function contentFiltersFormData(
  contentFilters: ContentFilters,
): FormData {
  const formData: FormData = new FormData();

  for (const key in contentFilters) {
    if (contentFilters.hasOwnProperty(key)) {
      appendFormData(formData, key, contentFilters[key]);
    }
  }

  return formData;
}
